(()=>{
  if(window.wrykindPsychedelicInstalled)return;
  window.wrykindPsychedelicInstalled=true;
  const mount=root=>{
    if(root.dataset.mounted)return;
    root.dataset.mounted='true';
    const reduce=matchMedia('(prefers-reduced-motion: reduce)');
    const button=root.querySelector('[data-wpk-pause]');
    const rails=root.querySelector('[data-wpk-rails]');
    const cards=[...root.querySelectorAll('[data-wpk-grid] > .wpk-card')];
    let paused=false;
    const enabled=root.dataset.motion==='true';
    const build=()=>{
      if(rails.children.length||cards.length<2)return;
      [0,1].forEach(parity=>{
        const rail=document.createElement('div');rail.className='wpk-rail';
        const track=document.createElement('div');track.className='wpk-track';
        const group=document.createElement('ul');group.className='wpk-track-group';
        const add=card=>{
          const clone=card.cloneNode(true);
          clone.querySelectorAll('a').forEach(a=>a.tabIndex=-1);
          clone.querySelectorAll('img').forEach(img=>{img.loading='lazy';img.removeAttribute('fetchpriority')});
          group.append(clone);
        };
        const selected=cards.filter((_,i)=>i%2===parity);
        selected.forEach(add);
        while(group.children.length<8)selected.forEach(add);
        track.style.animationDuration=`${Math.max(parseFloat(getComputedStyle(root).getPropertyValue('--wpk-speed'))||60,group.children.length*4)}s`;
        track.append(group,group.cloneNode(true));rail.append(track);rails.append(rail);
      });
    };
    const update=()=>{
      const canAnimate=enabled&&!reduce.matches;
      button.hidden=!canAnimate;
      if(canAnimate)build();
      rails.hidden=!canAnimate||cards.length<2;
      root.dataset.running=String(canAnimate&&!paused);
      button.setAttribute('aria-pressed',String(paused));
      button.textContent=paused?button.dataset.playLabel:button.dataset.pauseLabel;
    };
    button.addEventListener('click',()=>{paused=!paused;update()});
    reduce.addEventListener('change',update);
    const observer=new IntersectionObserver(entries=>{root.dataset.offscreen=String(!entries[0].isIntersecting)},{rootMargin:'150px'});
    observer.observe(root);
    root.wpkCleanup=()=>{observer.disconnect();reduce.removeEventListener('change',update)};
    update();
  };
  const start=scope=>scope.querySelectorAll('[data-wpk]').forEach(mount);
  start(document);
  document.addEventListener('shopify:section:load',event=>start(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-wpk]').forEach(root=>root.wpkCleanup?.()));
})();

